module.exports = __webpack_public_path__ + "img/hand-with-smartwatch-holding-smartphone.71ba8810.jpg";